import { generateRedirectUrl } from '@domain-group/javascript-utils'

const mergeHashQueryParamsWithRedirect = (params: { hash: string, includeRedirect?: boolean }) => {
  const { hash, includeRedirect } = params

  const redirect = includeRedirect ? `redirect=${generateRedirectUrl()}` : ''
  const joinCharacter = hash.includes('?') ? '&' : '?'

  return redirect ? `${hash}${joinCharacter}${redirect}` : hash
}

export default mergeHashQueryParamsWithRedirect
